function Description({ value }: { value: string }) {
  return (
    <div style={{ gridArea: 'description ' }}>
      <h2 className="max-w-xl text-sm whitespace-pre-wrap xl:max-w-3xl">
        {value}
      </h2>
    </div>
  )
}

export default Description
